'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, OutlinedInput, Typography } from '@mui/material';
import { useShallow } from 'zustand/shallow';
import { formatInputDisplayValue } from '../utils';
import { useBTCalculatorStore } from './calculatorStore';
export const ExistingDebtForm = () => {
  const $ = _c(39);
  const {
    debt,
    interestRate,
    debtError,
    interestRateError,
    setField
  } = useBTCalculatorStore(useShallow(_temp));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      flexDirection: "column",
      bgcolor: "neutral.lightest",
      borderRadius: 2,
      padding: 3,
      gap: 3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="textBold" sx={{
      fontSize: "18px"
    }}>Existing credit card debt</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography component="label" htmlFor="existing-debt-input" variant="textSmallBold" sx={{
      marginBottom: 1
    }}>Credit card debt to transfer</Typography>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      inputMode: "decimal"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Typography sx={{
      color: "neutral.main"
    }}>$</Typography>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== debt) {
    t6 = formatInputDisplayValue(debt);
    $[6] = debt;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== setField) {
    t7 = e => {
      const value = e.target.value.replace(/,/g, "");
      if (!/^(\d{1,7}(\.\d{0,2})?)?$/.test(value)) {
        return;
      }
      setField("debt", value);
    };
    $[8] = setField;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      "& .MuiOutlinedInput-input": {
        paddingX: 3,
        paddingY: 2
      },
      bgcolor: "white",
      borderRadius: 2
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t7) {
    t9 = <OutlinedInput id="existing-debt-input" inputProps={t4} startAdornment={t5} value={t6} onChange={t7} sx={t8} />;
    $[11] = t6;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== debtError) {
    t10 = debtError && <Typography variant="textExtraSmall" sx={{
      color: "reds.main",
      marginTop: 1
    }}>{debtError}</Typography>;
    $[14] = debtError;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <Box sx={t2}>{t3}{t9}{t10}</Box>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      display: "flex",
      flexDirection: "column"
    };
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Typography component="label" htmlFor="current-interest-rate-input" variant="textSmallBold" sx={{
      marginBottom: 1
    }}>Current interest rate (APR)</Typography>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      inputMode: "decimal"
    };
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Typography sx={{
      color: "neutral.main"
    }}>%</Typography>;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== interestRate) {
    t16 = formatInputDisplayValue(interestRate);
    $[23] = interestRate;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== setField) {
    t17 = e_0 => {
      const value_0 = e_0?.target.value;
      if (!/^(\d{1,2}(\.\d{0,2})?)?$/.test(value_0)) {
        return;
      }
      setField("interestRate", value_0);
    };
    $[25] = setField;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      "& .MuiOutlinedInput-input": {
        paddingX: 3,
        paddingY: 2
      },
      bgcolor: "white",
      borderRadius: 2
    };
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t16 || $[29] !== t17) {
    t19 = <OutlinedInput id="current-interest-rate-input" inputProps={t14} endAdornment={t15} value={t16} onChange={t17} sx={t18} />;
    $[28] = t16;
    $[29] = t17;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== interestRateError) {
    t20 = interestRateError && <Typography variant="textExtraSmall" sx={{
      color: "reds.main",
      marginTop: 1
    }}>{interestRateError}</Typography>;
    $[31] = interestRateError;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t19 || $[34] !== t20) {
    t21 = <Box sx={t12}>{t13}{t19}{t20}</Box>;
    $[33] = t19;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t11 || $[37] !== t21) {
    t22 = <Box sx={t0}>{t1}{t11}{t21}</Box>;
    $[36] = t11;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  return t22;
};
function _temp(state) {
  return {
    debt: state.form.debt,
    interestRate: state.form.interestRate,
    debtError: state.errors.debt,
    interestRateError: state.errors.interestRate,
    setField: state.setField
  };
}